module.exports = __webpack_public_path__ + "static/media/S1-8-Garjix-cod8.56e663c6.png";